import { TextProps } from "react-aria-components";

export enum MDSTextVariant {
  HeaderXl = "header-xl",
  HeaderL = "header-l",
  HeaderM = "header-m",
  HeaderS = "header-s",

  TextM = "text-m",
  TextSm = "text-sm",
  TextS = "text-s",
  TextXs = "text-xs",

  ParagraphSm = "paragraph-sm",
  ParagraphS = "paragraph-s",

  CodeTextSm = "code-text-sm",
  CodeParagraphSm = "code-paragraph-sm",
}

export enum MDSTextWeight {
  Regular = "regular",
  Medium = "medium",
  Smedium = "smedium",
  SemiBold = "semiBold",
  Bold = "bold",
  Extrabold = "extrabold",
}

export enum MDSTextOverflow {
  Regular = "regular",
  Ellipsis = "ellipsis",
  EllipsisWrap = "ellipsis-wrap",
}

export enum MDSTextColor {
  Primary = "primary",
  Secondary = "secondary",
  Tertiary = "tertiary",
  Contrast = "contrast",
  OnAccent = "onAccent",
  Link = "link",
  LinkHover = "linkHover",
  Emphasis = "emphasis",
  Positive = "positive",
  Danger = "danger",
}

export interface MDSTextProps extends TextProps {
  /**
   * Visual size/line-height/letter-spacing preset.
   */
  variant?: MDSTextVariant;

  /**
   * Font weight override. When omitted, a sensible default is chosen per variant.
   */
  weight?: MDSTextWeight;

  /**
   * Text color. When omitted, uses the default primary text color.
   */
  color?: MDSTextColor;

  /**
   * Render as a different HTML element, e.g. `span`, `p`, `h1`.
   */
  as?: keyof JSX.IntrinsicElements;

  /**
   * Text overflow behavior for truncation.
   */
  overflow?: MDSTextOverflow;

  /**
   * Maximum number of lines to display. When set, text will be truncated with ellipsis.
   */
  numberOfLines?: number;

  /**
   * Click handler.
   */
  onClick?: () => void;

  className?: string;
  id?: string;
}
